/* @flow */

const applyPreventDefault = (fun: Function) => (e: Event) => {
    e.preventDefault();
    fun(e);
    return false;
};

export default applyPreventDefault;
